import { SIZE_FULL } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

import { TiktokWidget } from '@/components/pages/analyze/widget/TiktokWidget';

export const mostRecentVideosConfig = {
    title: 'chart.tiktok.widget_most_recent_videos',
    id: 'widget_most_recent_posts',
    size: SIZE_FULL,
    sortFields: [
        'created',
        'engagement_rate',
        'video_views',
        'engagement_on_views',
        'likes',
        'comments',
        'shares'
    ],
    type: 'widget',
    element: TiktokWidget,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
